import React from 'react';
import { Link } from 'gatsby';

import AdobeSolutions from './../../assets/images/accreditations/Adobe_Solution_Partner_Bronze.png';
import LivingWageEmployer from './../../assets/images/accreditations/living-wage.webp';
import BCorp from './../../assets/images/accreditations/B-Corp-Logo-White-RGB.png';
import GooglePartner from './../../assets/images/accreditations/google-partner-logo.png';
import Ecologi from './../../assets/images/accreditations/Ecologi_Climate_Action_Workforce_Logo_Landscape_White.svg';

import Linkedin from '../../assets/images/icons/linkedin.svg';
import Facebook from '../../assets/images/icons/facebook.svg';
import Twitter from '../../assets/images/icons/x.svg';
import Instagram from '../../assets/images/icons/instagram.svg';
import Tiktok from '../../assets/images/icons/tiktok.svg';

import footerPod from '../../assets/images/RPF-Logo-Footer.webp';

const Footer = () => {

  let currentYear = new Date().getFullYear();

  const socialMedia = [
    { url: "https://www.linkedin.com/company/flaunt-digital/",
      alt: "LinkedIn",
      image: Linkedin,
    },
    { url: "https://en-gb.facebook.com/FlauntDigital/",
      alt: "Facebook",
      image: Facebook,
    },
    { url: "https://twitter.com/flauntdigital",
      alt: "Twitter",
      image: Twitter,
    },
    { url: "https://www.instagram.com/flauntdigital/",
      alt: "Instagram",
      image: Instagram,
    },
    { url: "https://www.tiktok.com/@flauntdigital",
      alt: "Tiktok",
      image: Tiktok,
    },
  ];

  const accreditations = [
    { url: "https://www.livingwage.org.uk/",
      alt: "Living Wage Employer",
      image: LivingWageEmployer,
    },
    { url: "https://www.bcorporation.net/en-us/find-a-b-corp/company/flaunt-digital/",
      alt: "B Corp",
      image: BCorp,
    },
    { url: "https://ecologi.com/flauntdigital",
      alt: "Ecologi",
      image: Ecologi,
    },
    { url: "https://www.google.com/partners/agency?id=5298196496",
      alt: "Google Partner",
      image: GooglePartner,
    },
    { url: "https://solutionpartners.adobe.com/s/directory/detail/flaunt%20digital/",
      alt: "Adobe Solutions Partner",
      image: AdobeSolutions,
    },
  ];

  return (
    <footer className="footer">
      <div className="footer-left">
        <div className="footer-address">
          <a 
            alt="Call us on +44 133 460 1232"
            href="tel:+441134601232"
          >+44 113 460 1232</a>
          <a
            alt="Email us @ contact@flauntdigital.com"
            href="mailto:contact@flauntdigital.com"
          >contact@flauntdigital.com</a>
          <a
            alt="Visit our office"
            href="https://www.google.com/maps/place/Flaunt+Digital/@53.7904173,-1.5554154,17z/data=!3m1!4b1!4m5!3m4!1s0x48795e9fe96aaaab:0xc6c6f1681d58f0b9!8m2!3d53.7904173!4d-1.5532267"
          >Marshalls Mill, Holbeck, Leeds LS11 9YJ</a>
          <a
            alt="Our privacy policy"
            href="/privacy-policy"
          >Privacy Policy</a>
        </div>
        <div className="social-icons">
          { socialMedia.map((site) => {
            return(
              <a 
                href= { site.url }
                className="social-icon"
                target="_blank"
                rel="noreferrer"
                key={ site.alt }
                title={`Follow us on ${site.alt}`}
              >
                <img 
                  alt={`${site.alt} Logo`}
                  className="social-icon-image"
                  loading="lazy"
                  src={ site.image }
                />
              </a>
            )
          }) }
        </div>
      </div>

      <div className="footer-middle">
        <div className="footer-qualifications-badges">
          {
            accreditations 
          && 
            accreditations.map((accreditation) => {
              return(
                <a key={ accreditation.alt } href={`${accreditation.url}`} rel="noreferrer" target="_blank">
                  <img
                    alt={`${accreditation.alt} Logo`}
                    loading="lazy"
                    src={ accreditation.image }
                  />
                </a>
              );
            })
          }
        </div>
        <div className="awards-text">
          <p>Looking for awards badges? Not on this site. All the awards we need are <Link to="/stories/" alt="All the awards we need are here">here.</Link></p>
        </div>
      </div>
      
      <div className="footer-right">
        <div className="footer-copyright">
          <p>&#169; { currentYear } Flaunt Digital. All Rights Reserved</p>
          <p>Company No. 09696176. VAT No. 235454510</p>
          <p>Established 2015</p>
        </div>
        <div className="footer-podcast">
          <Link to="/resting-pitch-face/" alt="Resting Pitch Face">
            <img 
              alt="Resting Pitch Face"
              loading="lazy"
              src={footerPod}
            ></img>
          </Link>
        </div>
      </div>
    </footer>
  )
}

export default Footer;